export interface AiPreviewItem {
  id: string;
  titleKey: string;
  descKey: string;
}

export const aiPreviewItems: AiPreviewItem[] = [
  { id: 'glossy', titleKey: 'aiPreview.glossy', descKey: 'aiPreview.glossy.desc' },
  { id: 'frosted', titleKey: 'aiPreview.frosted', descKey: 'aiPreview.frosted.desc' },
  { id: 'metallic', titleKey: 'aiPreview.metallic', descKey: 'aiPreview.metallic.desc' },
  { id: 'matte', titleKey: 'aiPreview.matte', descKey: 'aiPreview.matte.desc' },
  { id: 'color', titleKey: 'aiPreview.color', descKey: 'aiPreview.color.desc' },
  { id: 'uv', titleKey: 'aiPreview.uv', descKey: 'aiPreview.uv.desc' },
  { id: 'embossed', titleKey: 'aiPreview.embossed', descKey: 'aiPreview.embossed.desc' },
  { id: 'pearl', titleKey: 'aiPreview.pearl', descKey: 'aiPreview.pearl.desc' },
];